import { observer } from 'mobx-react-lite'
import { Text, View } from 'react-native'

import { GAME_CONFIG } from '@ppwr/poker'

import { BaseModalConfig } from '../'
import ChipsIcon from '../../../assets/Chips.svg'
import { BottomModalButton } from '../../../BottomModalContent/BottomModalButton'
import { ConfirmOption } from '../../../BottomModalContent/Content'
import { GameModal } from '@/screens/GameContainer/Modals/GameModalContainer'
import { translate } from '../../../../../i18n'
import { styles } from './BuyChip.style'

export interface BuyChipProps extends BaseModalConfig {
  visible?: boolean
  confirm: ConfirmOption
  cancel: ConfirmOption
}

export const BuyChip = observer(({ visible, onClose, confirm, cancel }: BuyChipProps) => {
  const amount = GAME_CONFIG.DEFAULT_REBUY_AMOUNT_FOR_QUICK_GAME.toLocaleString()

  const content = (
    <View style={styles.modalContainer}>
      <View style={styles.chipContainer}>
        <ChipsIcon height={56} width={56} />
      </View>
      <View style={styles.container}>
        <Text style={styles.titleStyle}>{translate('gameScreen.buyChip.title')}</Text>
        <Text style={styles.subTitleStyle}>{translate('gameScreen.buyChip.subtitle', { amount })}</Text>
        <BottomModalButton
          text={confirm.text}
          onPress={confirm.onPress}
          size="large"
          alternateFont
          textStyle={[styles.buttonTitleStyle]}
        />
        <BottomModalButton
          text={cancel.text}
          onPress={cancel.onPress}
          size="large"
          alternateFont
          alternateColor
          textStyle={[styles.buttonTitleStyle]}
        />
      </View>
    </View>
  )

  if (visible != null) {
    return (
      <GameModal visible={visible} onClose={onClose}>
        {content}
      </GameModal>
    )
  }

  return content
})
